// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-link.el-link--primary[data-v-70f2d162]{font-size:17px;line-height:23px;color:#158ad2;margin-bottom:17px;opacity:1}", ""]);
// Exports
module.exports = exports;
